import produce from 'immer';

import {
  CLEAR_ERRORS,
  SAVE_FAILED,
  SAVE_STARTED,
  SET_SETTINGS,
} from './actions';

const emptyState = {
  enabled: false,
  errors: [],
  grossCommissionTotal: 0,
  royaltyPercent: null,
  saving: false,
};

export default produce((state, action) => {
  switch (action.type) {
  case CLEAR_ERRORS:
    state.errors = [];
    break;
  case SAVE_STARTED:
    state.saving = true;
    state.errors = [];
    break;
  case SAVE_FAILED:
    state.saving = false;
    state.errors = action.errors;
    break;
  case SET_SETTINGS:
    state.saving = false;
    state.enabled = action.enabled;
    state.royaltyPercent = action.royaltyPercent;
    break;
  }
}, emptyState);
